import React from "react";
import { useSelector } from "react-redux";
import { Wrapper } from "./expired.styles";
import cryFace from "../animatedGifs/tracker-sad-optimised.gif";
import { GradientButton } from "./gradientButton";
import { themes } from "@theme/config";
import { removeIdFromQueryString } from "../helpers";

export const Expired = () => {
  const { themeName } = useSelector((state) => state.StartUp.theme);
  const queryString = useSelector((state) => state.StartUp.queryString);

  let href = '/apply';
  if (themeName === themes.fgfParent.rent.themeName) {
    const string = removeIdFromQueryString(queryString);
    href = `/apply?${string}`
  }

  return (
    <Wrapper>
      <img
        className="animated-gif-sad"
        src={cryFace}
        alt="your application has expired!"
      />
      <h3>Your application has expired!</h3>
      <p>
        If you still need a loan from us, please click on the button below to
        reapply.
      </p>
      <GradientButton
        href={href}
        className="apply-button"
        buttonText="Reapply Now"
      />
    </Wrapper>
  );
};
